import { produce } from "immer";
import { set as _set } from "lodash";

import { IMiddleware, TSource } from "../interfaces";

export const StringMiddleware: IMiddleware = {
  check(datasource: TSource) {
    return datasource.type === "scalar" && datasource.dataType === "string";
  },
  create(datasource) {
    if (!StringMiddleware.check(datasource)) return;
  },
  set(root, _, value, ctx) {
    const { value: state } = ctx;
    const datasource = state.sources[root];

    if (!datasource || !StringMiddleware.check(datasource)) return;

    const newValue = produce(state, (draft) => {
      _set(draft.sources, `${root}.value`, value);
    });

    ctx.next(newValue);
  },
};
